// Package Imports
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
// import { useBack } from '@refinedev/core';
import { useNavigate } from 'react-router-dom';
import resourceName from 'core/common/resourceName';
// Project Imports

const TitleCard = ({ config }: any) => {
  const { title, onClick } = config || {};
  const { Title } = Typography;
  // const back = useBack(); // when back page is not fixed
  const navigate = useNavigate();
  const breadcrumb = JSON.parse(localStorage.getItem('breadcrumbList') || '[]');

  function customGgoToList() {
    let link = `/${resourceName.teamLeadDashboard}`;
    if (breadcrumb.length > 0) {
      link = breadcrumb[breadcrumb.length - 1]?.url;
    }
    if (onClick) {
      onClick();
    } else {
      navigate(link);
    }
    // if (goToList) {
    //   console.log("GO TO LIST")
    //   goToList();
    // } else {
    //   console.log("BACK")
    //   back();
    // }
  }
  return (
    <Flex align="center" className="">
      <Button
        type="text"
        className="mr-4 flex justify-center items-center font-medium text-base"
        icon={<ArrowLeftOutlined />}
        onClick={customGgoToList}
      />
      <Title className="!my-3" level={4}>
        {title}
      </Title>
    </Flex>
  );
};

export default TitleCard;
